import { Spinner } from "flowbite-react";

export const CenteredSpinner = () => {
  return (
    <div className="w-full h-full flex items-center justify-center" aria-label="Spinner animé et centré">
      <Spinner size="lg" />
    </div>
  );
};
